<template>
  <div>
    <crud-input
      :field="field"
      :options="options"
      v-model="value"
      :allow-empty="true"
      :override-type="options.type === 'reference' || options.type === 'enum' ? 'references' : options.type"
      :override-values="options.type === 'enum' ? convertEnum(options.values) : null"
      :filter="true"
      no-rules
    />
  </div>
</template>

<script>
import CrudInput from './CrudInput'

export default {
  props: {
    options: Object,
    field: String,
    value: Object
  },
  components: {
    CrudInput
  },
  methods: {
    convertEnum (values) {
      return Object.keys(values).map(field => {
        return {
          _self: field,
          name: values[field]
        }
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// CrudFilter.vue?32397446